<template>
  <div>
    <div class="from-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" @change="cambiarDatos($event)" class="form-control">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un tipo de movimiento</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los tipos de movimientos</option>        
        <option v-for="(tipoMovimientos,index) in tiposMovimientos" :value="tipoMovimientos.TipoMovimientoId" :key="index">{{tipoMovimientos.Nombre}}</option>
      </select>      
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import axios from 'axios'

  export default {
    data() {
      return {
        enumeraciones,
        tiposMovimientos: [],
        idDelModelo:null
      }
    },
    props: {            
      parametros:Object,
      valorDefinido:Number,
      idDelInput:String,      
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      }
    },
    computed:{
      
    },
    methods: {
      /**
       * Metodo para asignar la llave del elmento seleccionado del catalogo C016TiposMovimientos
       * @param {object} evento [evento emitido por el select]
       */
      cambiarDatos(evento){
        this.idDelModelo = evento.target.value;
        const valoresDelCatalogo =
        {
          llave: this.idDelInput,
          valor: evento.target.value 
        }

        this.$store.dispatch("A_SIVAC_Catalogos_016TiposMovimientos",valoresDelCatalogo);
        this.$emit("valorParaElPadre",evento);
        // para obtener label del select => let labelTipoPagina = evento.target.options[evento.target.selectedIndex].text;
      },
      /**
       * Metodo para llenar catalogo C016TiposMovimientos mediante el llamado de la API
       */
      cargarTiposMovimientos: function() {
        // definimos metodo de API
        const SERVIDOR = api.conexion;
        const METODO_API_AGREGAR = api.SIVAC.catalogos.C016TiposMovimientos;
        let urlApi = SERVIDOR + METODO_API_AGREGAR;
        // creamos la peticion con el formulario
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {};
        
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba;
        let peticionMetodoGetTiposMovimientosAPI = this.parametros;
        // contruir header de la peticion
        let peticionArchivos = false;
        let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos);
        comun.SeEstaCargandoInformacion(true);
        axios.post(urlApi, peticionMetodoGetTiposMovimientosAPI, headerPeticion)
                .then(respuesta => {            
                    if (respuesta.data.SiHayError) {
                        console.log(respuesta); 
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    } else {
                        /* utilizar solo en etapa de desarrollo 
                        console.log("ejecuto bien paginas controller:: ",respuesta.data); */
                        this.tiposMovimientos = respuesta.data.TiposMovimientos;

                    if(this.parametros.elementosAOmitir != undefined){
                     this.tiposMovimientos = this.tiposMovimientos.filter(element => {                   
                     if(!this.parametros.elementosAOmitir.includes(element.TipoMovimientoId))
                    return element;
                    });
                    }

                    if(this.parametros.elementosAConservar != undefined && this.parametros.elementosAConservar != null  && this.parametros.elementosAConservar.length > 0){
                      this.tiposMovimientos = this.tiposMovimientos.filter(element => {                  
                    if(this.parametros.elementosAConservar.includes(element.TipoMovimientoId))
                    return element;
                    });
                    }



                    }
                    comun.SeEstaCargandoInformacion(false);
                })
                .catch(excepcion => {
                    comun.SeEstaCargandoInformacion(false);
                    console.log(excepcion);
                    comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
                }
        ) // axios.post
      }
    }, 
    mounted(){
      // establecer valor default
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

        const valoresDelCatalogo = {
          llave: this.idDelInput,
          valor: this.idDelModelo
        }
      this.$store.dispatch("A_SIVAC_Catalogos_016TiposMovimientos", valoresDelCatalogo);
    },
    created() {
      this.cargarTiposMovimientos();
    }
  }
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/SIVAC/Catalogos/C016TiposMovimientos.vue